<template>
  <div v-if="displayStatus" class="status-badge" :class="['status-' + displayStatus.detailed_status]">
    {{ displayStatusText }}
  </div>
</template>

<script>
export default {
  name: 'StatusBadge',
  props: {
    displayStatus: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    displayStatusText () {
      // detailed_status as a fallback, should not be used as it's not translated
      return this.displayStatus.display_status || this.displayStatus.detailed_status
    }
  },
}
</script>

<style lang="scss" scoped>

</style>